import router from "../../../shared/router";
import SsoCallback from './SsoCallback.vue';

let {routes} = router.options;
const route = routes.find(r => r.path === '/auth');
route.children.push({
  path: 'sso/callback',
  name: 'sso-callback',
  component: SsoCallback,
  meta: {
    guest: true
  }
});
router.addRoutes([route]);
